export const GET_ALL_SCHEDULE_DATA_REQUEST = "GET_ALL_SCHEDULE_DATA_REQUEST";
export const GET_ALL_SCHEDULE_DATA_SUCCESS = "GET_ALL_SCHEDULE_DATA_SUCCESS";
export const GET_ALL_SCHEDULE_DATA_FAILURE = "GET_ALL_SCHEDULE_DATA_FAILURE";

export const GET_SHEDULE_TEAM_ID_REQUEST = "GET_SHEDULE_TEAM_ID_REQUEST";
export const GET_SHEDULE_TEAM_ID_SUCCESS = "GET_SHEDULE_TEAM_ID_SUCCESS";
export const GET_SHEDULE_TEAM_ID_FAILURE = "GET_SHEDULE_TEAM_ID_FAILURE";


